import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaMagnifyingGlass } from "react-icons/fa6";
import TrainingOverviews from "./index";
import ViewTrainingOverview from "./view";
import EditTrainingOverview from "./edit";
import { MODULE_TRAINING } from "variables/constants";

const trainingOverviewRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Overview",
		basePath: "training-overviews",
		mainComponent: <TrainingOverviews />,
	    layout: "/console",	   
	    icon: <FaMagnifyingGlass className="icon-item" />,
	    subTitle:"Training Overview",
	    viewComponent: <ViewTrainingOverview />,
	    createComponent: <EditTrainingOverview />,
	    editComponent: <EditTrainingOverview />,
		level:5,
		moduleId: MODULE_TRAINING,
	})
]

export default trainingOverviewRoutes;